import {
  homeMetricsResponseSchema,
  paths,
  type HomeMetricsResponse,
  type Period,
} from "@go-novus/admin-api";

import {
  requestBackendResult,
  type BackendFailure,
} from "#/shared/lib/backend-api";
import type { ResultAsync } from "#/shared/lib/result";

/** 这个 feature 的语义读操作名，失败会带上它，UI 据此挑文案。 */
export const getHomeMetricsOperation = "home_metrics.read";

export type GetHomeMetricsOperation = typeof getHomeMetricsOperation;

export type GetHomeMetricsFailure = BackendFailure<GetHomeMetricsOperation>;

export function getHomeMetrics(
  period: Period,
  options: { fetch?: typeof globalThis.fetch; signal?: AbortSignal } = {},
): ResultAsync<HomeMetricsResponse, GetHomeMetricsFailure> {
  return requestBackendResult({
    fetch: options.fetch,
    method: "GET",
    operation: getHomeMetricsOperation,
    parse: (payload) => homeMetricsResponseSchema.parse(payload),
    path: `${paths.homeMetrics}?${new URLSearchParams({ period }).toString()}`,
    signal: options.signal,
  });
}
